import _ from 'underscore';
import { setUpErrorHandling } from '@bingads-webui-campaign/summary-grid-helper';
import { TargetingSettingsContext } from '@bingads-webui-campaign/targeting-settings-scaffolds';
import { SettingsGridView } from './settings-grid-view';
import { getConfig } from './settings-grid-config';
import { getPlugins } from './settings-grid-plugins';
import SettingsGridColumnsConfig from './settings-grid-column-config';
import SettingsRepository from './settings-repository';

export function createAllSettingsGrid({
  // New UI options only
  filterService,
  router,
  viewport,
  customHeaderOffset,
  // common options
  preferenceConfig,
  dataSource,
  gridName,
  getAdditionalPlugins,
  perfMarker,
  prefetchChunks,
  getCampaignTypeGlobalFilter,
  instrumentation,
}) {
  const columnConfig = new SettingsGridColumnsConfig();
  const repository = _.isUndefined(dataSource)
    ? new SettingsRepository()
    : new dataSource.SettingsRepository();

  return new SettingsGridView({
    router,
    filterService,
    preferenceConfig,
    getGridConfig: view => getConfig({
      repository,
      gridName,
      view,
      filterService,
      preferenceConfig,
      columnConfig,
      router,
      viewport,
      customHeaderOffset,
      i18n: TargetingSettingsContext.i18n,
    }),
    getGridPlugins: view => getPlugins({
      columnConfig,
      perfMarker,
      getCampaignTypeGlobalFilter,
      instrumentation,
    }).concat(getAdditionalPlugins(view)),
    setupDataSourceErrorHandling: view => setUpErrorHandling({
      gridView: view,
      scope: {},
      dataSource: repository.getDataSource(),
      i18n: TargetingSettingsContext.i18n,
    }),
    prefetchChunks,
    instrumentation,
  });
}
